<template>
  <div class="mask" v-if="isShowDialog">
    <div class="dialogWrp">
      <div class="contentWrp">
        <div class="title">课程级别</div>
        <div class="levelItem" :class="item.value == level ? 'selected' : ''" v-for="(item,index) in levelList" :key="index" @click="setLevel(item.value)">{{item.text}}</div>
        <img :src="`${imgUrl}close.png`" class="close" @click="close" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    levelList: {
      type: Array,
      default: () => []
    },
    level: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      imgUrl: 'https://sc2.hexiaoxiang.com/h5/purchase/img/',
      isShowDialog: false
    };
  },
  methods: {
    show() {
      this.isShowDialog = true;
    },
    close() {
      this.isShowDialog = false;
    },
    setLevel(value) {
      this.$emit('setLevel', value);
      this.isShowDialog = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
}
.dialogWrp {
  box-sizing: border-box;
  width: 100%;
  background: #ffffff;
  border-radius: 15px 15px 0 0;
  position: absolute;
  bottom: 0;
  padding: 15px 15px 30px;
  display: flex;
  flex-direction: column;

  .contentWrp {
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 20px;
    .close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 0;
      right: 0;
    }

    .title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 20px;
      color: #3c3531;
      margin-bottom: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .levelItem {
      height: 50px;
      background: #f6f6f6;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #3c3531;
      margin-top: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .selected {
      background: #fffae7;
      border: 1px solid #f8cf00;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #3c3531;
    }
  }
}
</style>
